export default {
    key: 'unlimited-pass-summer',
    common: {
        productName: 'core.productNames.unlimited-pass-summer',
        splashMessage: 'offerFlow.splashMessage.unlimited-pass-summer',
        headingAside: 'offerFlow.headingAside.unlimited-pass-summer',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.unlimited-pass-summer',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.unlimited-pass-summer',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
